import React from 'react';
import { motion } from 'framer-motion';
export function DownloadArea() {
  return <section className="py-16 px-4 bg-[#FDF8F3]" id="download-section" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-6" data-id="element-3">
          <p className="text-[#8A7A6D] text-sm" data-id="element-4">
            No quiero esta oferta, prefiero ir a mi descarga.
          </p>

          <a href="https://drive.google.com/drive/folders/1-VVUyFqeAiJv3ouLZTbB3hdMKE3LYGNS?usp=sharing" target="_blank" rel="noopener noreferrer" className="w-full block bg-[#C17F3E] hover:bg-[#A66A32] text-white px-8 py-5 rounded-xl font-bold text-lg md:text-xl transition-all duration-200 shadow-[0_4px_20px_rgba(193,127,62,0.3)] hover:shadow-[0_6px_25px_rgba(193,127,62,0.4)] hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#C17F3E] focus:ring-offset-2 focus:ring-offset-[#FDF8F3]" aria-label="Descargar Patrones Mascotas" data-id="element-5">
            ⬇ Descargar Patrones Mascotas
          </a>
        </motion.div>
      </div>
    </section>;
}